<!--
 * @Author: Jason
 * @Date: 2019-10-15 17:32:50
 * @version:
 * @LastEditors: Jason
 * @LastEditTime: 2019-10-29 14:23:28
 * @Descripttion:
 -->
<template>
    <div class="login">
        <v-head :isShowBack="$route.meta.isShowIcon">登录</v-head>
        <div class="mt login-title">请输入登录信息</div>
        <div class="flex-btwn-aic login-item">
            <img src="./../assets/imgs/icon_login_tel.png" alt="" />
            <input
                class="login-tel"
                v-model="tel"
                @input="tel = tel.replace(/\s/g, '')"
                type="tel"
                placeholder="请输入手机号码"
            />
        </div>
        <div class="flex-btwn-aic login-item">
            <img src="./../assets/imgs/icon_login_code.png" alt="" />
            <input
                class="login-code"
                type="tel"
                v-model="telcode"
                @input="telcode = telcode.replace(/\s/g, '')"
                placeholder="请输入验证码"
            />
            <div class="login-btn-code" @click="getTelCode()">{{ codeText }}</div>
        </div>

        <div class="login-btn" @click="login()">登录</div>

        <div id="qrcode" ref="qrcode" v-if="isShowCode">
            <div class="titalText">{{ placeholderText }}</div>
            <div>
                <img class="ImgBase64" :src="ImgBase64" alt="" />
                <input
                    class="point-info-item inputTe"
                    v-model="inputValue"
                    :placeholder="placeholderText"
                    type="text"
                />
            </div>
            <div class="order-close-btn checkBt">
                <span @click="isShowCode = false">取消</span>
                <span @click="checkFun()">确定</span>
            </div>
        </div>
        <div class="qrcode_bg" v-if="isShowCode"></div>
    </div>
</template>

<script>
    import vHead from '@/components/vHead.vue';
    import { ls, encryptWord, decryptWord } from '@/assets/js/utils.js';
    import { GetCheckCode, GetLogin } from '@/api/user.js';
    import { GetPostGet } from '@/api/point.js';
    export default {
        components: {
            vHead,
        },
        data() {
            return {
                tel: '',
                telcode: '',
                codeText: '获取验证码',
                codeTime: 120,
                timeOut: null,

                isShowCode: false,
                placeholderText: '请输入图形验证码',
                inputValue: '',
                ImgBase64: '',
            };
        },
        mounted() {
            let _ = this;
            document.body.style.backgroundColor = '#fff';
        },
        methods: {
            getCodeText() {
                let _ = this;
                if (_.codeTime == 0) {
                    _.codeText = '获取验证码';
                    clearTimeout(_.timeOut);
                    return;
                }
                _.codeText = `${_.codeTime}s后重新获取`;
                _.codeTime--;
                _.timeOut = setTimeout(() => {
                    _.getCodeText();
                }, 1000);
            },
            getTelCode() {
                let _ = this;
                if (_.codeText != '获取验证码') return;
                _.tel = _.tel.replace(/(^\s*)|(\s*$)/g, '');
                console.log('输入的手机号码为', _.tel);
                if (!_.tel) {
                    _.toast('请输入手机号码！');
                    return;
                }
                if (!/^1[0-9]\d{9}$/.test(_.tel)) {
                    _.toast('请输入正确格式的手机号码！');
                    return;
                }

                if (sessionStorage.checkNum == 'true') {
                    _.GetcaptchaFun();
                    return;
                }
                let pars = {
                    telephone: _.tel,
                    vCode: '',
                    token: '',
                };
                GetCheckCode(pars)
                    .then(res => {
                        _.toast('已发送');
                        _.getCodeText();
                    })
                    .catch(err => {
                        console.log('获取信息失败', err);
                        if (err && err.resultDes) {
                            if (err.resultCode == '500001') {
                                sessionStorage.checkNum = 'true';
                                _.GetcaptchaFun();
                            } else {
                                _.toast(err.resultDes);
                            }
                        }
                    });
            },
            login() {
                let _ = this;
                _.tel = _.tel.replace(/(^\s*)|(\s*$)/g, '');
                _.telcode = _.telcode.replace(/(^\s*)|(\s*$)/g, '');
                console.log('输入的手机号码为', _.tel);
                if (!_.tel) {
                    _.toast('请输入手机号码！');
                    return;
                }
                if (!/^1[0-9]\d{9}$/.test(_.tel)) {
                    _.toast('请输入正确格式的手机号码！');
                    return;
                }
                if (!_.telcode) {
                    _.toast('请输入验证码！');
                    return;
                }
                if (!/^[0-9]{4,6}$/.test(_.telcode)) {
                    _.toast('请输入正确格式的验证码！');
                    return;
                }
                // type 1 公众号  2 APP
                const source = 'NHSXETC';
                // const params = `${_.tel}+${source}`; //加密原参数
                const sign = this.$aes.encrypt(_.tel + _.telcode + source); //加密后
                console.log(sign);
                let pars = {
                    telephone: _.tel,
                    checkCode: _.telcode,
                    sign,
                };

                GetLogin(pars)
                    .then(res => {
                        let { sign } = res
                        let decryptWordCode = decryptWord(sign)
                        let targetCode = `${_.tel}${_.telcode}`
                        console.log(sign,decryptWord(sign), '解密后的字符>>>>>>>>>>')
                        if (decryptWordCode != targetCode ) {
                            _.toast('验签失败！');
                            return;
                        }
                        ls.setter('loginStatus', res.token, 180 * 24 * 60 * 60 * 1000);
                        // const resSign = this.$aes.decrypt(decodeURIComponent(res.sign));
                        // console.log(resSign);
                        // if (resSign != params) {
                        //     _.toast('未知错误');
                        //     return;
                        // }
                        if (res.resultCode == '9999') {
                            _.toast(err.resultDes);
                            return;
                        }
                        _.$router.replace('/home');
                    })
                    .catch(err => {
                        console.log('获取信息失败', err);
                        if (err && err.resultDes) {
                            _.toast(err.resultDes);
                        }
                    });
            },
            GetcaptchaFun() {
                //图形验证码
                let _ = this;
                let parms = {
                    url:
                        'http://192.168.166.6:9141/gateway/captcha?telphone=' +
                        _.tel +
                        '&source=NHSXETC',
                    // url:'http://h5.schengle.com/gateway/captcha?telphone='+_.tel+'&source=NHSXETC',
                    params: {
                        // telephone: _.tel,
                        // source: "NHSXETC"
                    },
                };

                GetPostGet(parms)
                    .then(res => {
                        _.ImgBase64 = '';
                        console.log('GetPostGet::' + res);
                        console.log('GetPostGet::' + res.resultCode);
                        let data = JSON.parse(res.result);
                        if (data.success) {
                            _.ImgBase64 = data.data.imgBase64;
                            _.isShowCode = true;
                            sessionStorage.ImageValue = data.data.value;
                        } else {
                            _.$toast(res.resultDesc);
                        }
                    })
                    .catch(err => {
                        _.$toast(err.resultDesc);
                    });
            },
            checkFun() {
                let _ = this;
                let ImageValue = sessionStorage.ImageValue;
                console.log('ImageValue：：' + ImageValue);
                console.log('_.inputValue：：' + _.inputValue);
                if (ImageValue.toLowerCase() == _.inputValue.toLowerCase()) {
                    console.log('解除验证：：');
                    sessionStorage.checkNum = 'false'; //解除验证
                    _.getTelCode();
                    _.isShowCode = false;
                } else {
                    console.log('nooooooo解除验证：：');
                    _.placeholderText = '图形验证码错误！';
                    _.inputValue = '';
                    _.GetcaptchaFun();
                }
            },
        },
    };
</script>
<style lang="scss" scoped>
    .login {
        @mixin loginItem {
            width: 100%;
            height: 12vw;
            padding: 0 4vw;
            border-bottom: 1px solid #f4f5f7;
        }
        .login-title {
            width: 100%;
            text-align: center;
            padding-top: 16vw;
            font-weight: bold;
            font-size: 4.8vw;
            margin-bottom: 4vw;
        }
        .login-item {
            @include loginItem;
            background-color: #fff;
            img {
                width: 6vw;
                height: 6vw;
                display: block;
                margin-right: 1.3333vw;
            }
            .login-tel {
                width: 100%;
                height: 100%;
                font-size: 4vw;
            }
            .login-code {
                width: 60%;
                height: 100%;
                font-size: 4vw;
            }
            .login-btn-code {
                width: 40%;
                text-align: center;
                height: 9vw;
                border-radius: 2vw;
                // border: 1px solid #0059BF;
                font-size: 4vw;
                color: #16a085;
                line-height: 9vw;
                border-left: 1px solid #f4f5f7;
            }
        }
        .login-btn {
            margin: 18vw 4vw 0;
            height: 12vw;
            line-height: 12vw;
            color: #fff;
            background-color: #16a085;
            text-align: center;
            font-size: 4vw;
            border-radius: 6vw;
        }
    }

    #qrcode {
        padding: 10px 30px 20px;
        background: #ffffff;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 100;
        .qrcode-tips {
            color: red;
            width: 100%;
            text-align: center;
        }
    }
    .qrcode_bg {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 99;
        background: rgba(0, 0, 0, 0.6);
    }
    .titalText {
        line-height: 35px;
        margin: 10px auto;
        text-align: center;
        font-size: 16px;
    }
    .ImgBase64 {
        width: 120px;
        margin: 0 auto;
        display: block;
    }
    .inputTe {
        border: 1px solid #cccccc;
        width: 180px;
        height: 35px;
        margin: 5px 0 15px 0;
        padding: 0;
        text-indent: 5px;
    }
    .checkBt {
        display: block;
        font-size: 16px;
        height: 45px;
        line-height: 45px;
        text-align: center;
        color: #fff;
        span {
            display: inline-block;
            width: 43%;
            text-align: center;
            // background: #668aea;
            background: #f85b46;
        }
        span:nth-of-type(1) {
            margin-right: 10%;
        }
    }
</style>
